import React, { useState } from "react";
import { Button, Drawer, Flex, Grid, Menu } from "antd";
import { MenuOutlined } from "@ant-design/icons";

const { useBreakpoint } = Grid;

const navItems = [
  { key: "/", label: "Home" },
  { key: "/about", label: "About" },
  { key: "/pricing", label: "Pricing" },
  { key: "/community", label: "Community" },
];

export default function PublicHeader({ logo, accessToken }) {
  const [navOpen, setNavOpen] = useState(false);
  const screens = useBreakpoint();
  const isMobile = screens.md === false;

  const authAction = accessToken ? (
    <Button type="primary" href="/app">
      Go to Dashboard
    </Button>
  ) : (
    <Flex gap="middle" align="center" justify="flex-start">
      <Button type="default" href="/login">
        Login
      </Button>
      <Button type="primary" href="/signup">
        Get Started
      </Button>
    </Flex>
  );

  return (
    <header
      className="public-marketing-header"
      style={{
        marginTop: "1rem",
        borderRadius: "6px",
        padding: "0.5rem",
      }}
    >
      <Flex gap="large" align="center" justify="space-between" wrap>
        <Flex gap="middle" align="center">
          {isMobile ? (
            <Button
              type="text"
              icon={<MenuOutlined />}
              onClick={() => setNavOpen(true)}
              aria-label="Open navigation menu"
            />
          ) : null}
          <img
            src={logo}
            alt="Mailinflow Logo"
            height={30}
            style={{ marginLeft: "0.25rem" }}
          />
        </Flex>
        {isMobile ? null : (
          <Flex gap="middle" align="center" justify="flex-start">
            <Button type="link" href="/">
              Home
            </Button>
            <Button type="link" href="/about">
              About
            </Button>
            <Button type="link" href="/pricing">
              Pricing
            </Button>
            <Button type="link" href="/community">
              Community
            </Button>
          </Flex>
        )}
        {authAction}
      </Flex>
      <Drawer
        placement="left"
        width="min(280px, 90vw)"
        open={navOpen}
        onClose={() => setNavOpen(false)}
        styles={{ body: { padding: 0 } }}
      >
        <Menu
          mode="inline"
          items={navItems.map((item) => ({
            key: item.key,
            label: <a href={item.key}>{item.label}</a>,
          }))}
        />
      </Drawer>
    </header>
  );
}
